import {useQuery} from 'react-query'
import {SAVApiStatusResponse} from '../../../../@types'
import {Get} from '../../../../../setup'

const TICKETS_STATUS = process.env.REACT_APP_SAV_TICKETS_STATUS || 'sav/ticket-status'

export const useTicketStatus = () => {

    const {data, isLoading, isError} = useQuery(
        ['TICKET_STATUS'],
        () => Get<SAVApiStatusResponse>({endpoint: TICKETS_STATUS}),
        {
            staleTime: 5 * 60 * 1000,
            cacheTime: 10 * 60 * 1000,
            select: (data) => ({
                status: data.status,
                urgency: data.urgency,
            }),
        },
    )

    return {
        status: data?.status || [],
        urgency: data?.urgency || [],
        isLoading, isError
    }
}